import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSystemSettings } from '../../contexts/SystemSettingsContext';
import './Navbar.css';

const Navbar = () => {
  const [overHero, setOverHero] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { socialLinksEnabled, socialLinks } = useSystemSettings();

  // Platform configurations with icons
  const platformConfigs = [
    {
      key: 'instagram',
      name: 'Instagram',
      icon: (

<svg
  width="20"
  height="20"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
>
  <path
    d="M12 2.2c3.2 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.332.014 7.052.072 2.694.272.272 2.694.072 7.052.014 8.332 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.332 23.986 8.741 24 12 24s3.668-.014 4.948-.072c4.358-.2 6.78-2.618 6.98-6.98.058-1.281.072-1.689.072-4.948 0-3.259-.014-3.667-.072-4.947C23.728 2.694 21.306.272 16.948.072 15.668.014 15.259 0 12 0zM12 5.838c-3.403 0-6.162 2.759-6.162 6.162S8.597 18.162 12 18.162 18.162 15.403 18.162 12 15.403 5.838 12 5.838zm0 10.162c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zm6.406-11.845a1.44 1.44 0 110 2.88 1.44 1.44 0 010-2.88z"
    fill="currentColor"
  />
</svg>

      ),
      color: '#E4405F'
    },
    {
      key: 'facebook',
      name: 'Facebook',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      color: '#1877F2'
    },
    {
      key: 'youtube',
      name: 'YouTube',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      ),
      color: '#FF0000'
    },
    {
      key: 'linkedin',
      name: 'LinkedIn',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ),
      color: '#0077B5'
    },
    {
      key: 'twitter',
      name: 'Twitter/X',
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      ),
      color: '#1DA1F2'
    }
  ];

  // Get enabled platforms with URLs, sorted by enabled_at (oldest first, newest last = rightmost)
  const enabledPlatforms = platformConfigs
    .filter(platform => 
      socialLinksEnabled && socialLinks[platform.key]?.enabled && socialLinks[platform.key]?.url
    )
    .sort((a, b) => {
      const aTime = socialLinks[a.key]?.enabled_at;
      const bTime = socialLinks[b.key]?.enabled_at;
      
      // If no enabled_at, treat as very old (shouldn't happen, but fallback)
      if (!aTime && !bTime) return 0;
      if (!aTime) return -1; // a goes left (older)
      if (!bTime) return 1;  // b goes left (older)
      
      // Sort ascending: oldest first (left), newest last (right)
      return new Date(aTime) - new Date(bTime);
    });

  // Lock body scroll when menu is open
  useEffect(() => {
    document.documentElement.style.overflow = menuOpen ? 'hidden' : '';
    return () => (document.documentElement.style.overflow = '');
  }, [menuOpen]);

  // Close on ESC
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setMenuOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  // Detect "over hero"
  useEffect(() => {
    const heroEl =
      document.querySelector('#hero') ||
      document.querySelector('.hero') ||
      document.querySelector('.hero-section');

    if (!heroEl) { setOverHero(false); return; }

    const navbarHeight = 80;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setOverHero(entry.isIntersecting);
        document.body.classList.toggle('on-hero', entry.isIntersecting);
      },
      { root: null, threshold: 0, rootMargin: `-${navbarHeight}px 0px 0px 0px` }
    );

    observer.observe(heroEl);
    return () => observer.disconnect();
  }, []);

  const closeMenu = () => setMenuOpen(false);


  // Handle navigation clicks
  const handleNavClick = (e, target) => {
    e.preventDefault();
    closeMenu();
    
    if (target === 'learn-more') {
      if (location.pathname !== '/') {
        // If not on home page, navigate to home first, then scroll
        window.location.href = '/#bright-tomorrow';
      } else {
        // On home page, exit hero (if present) then scroll to BrightTomorrow
        const exitHeroIfNeeded = () => {
          if (document.body.classList.contains('on-hero') && typeof window.enterContent === 'function') {
            window.enterContent();
          }
        };

        const scrollWhenReady = (attempts = 12) => {
          const element = document.getElementById('bright-tomorrow');
          const scroller = document.querySelector('.content-scroller');
          if (element && scroller) {
            const elementOffsetTop = element.offsetTop;
            scroller.scrollTo({ top: Math.max(0, elementOffsetTop - 80), behavior: 'smooth' });
            return;
          }
          if (attempts > 0) setTimeout(() => scrollWhenReady(attempts - 1), 50);
        };

        exitHeroIfNeeded();
        setTimeout(() => scrollWhenReady(), 120);
      }
    } else if (target === 'platforms') {
      if (location.pathname !== '/') {
        // If not on home page, navigate to home first, then scroll
        window.location.href = '/#providers';
      } else {
        // On home page, exit hero (if present) then scroll to Providers
        const exitHeroIfNeeded = () => {
          if (document.body.classList.contains('on-hero') && typeof window.enterContent === 'function') {
            window.enterContent();
          }
        };

        const scrollWhenReady = (attempts = 12) => {
          const element = document.getElementById('providers');
          const scroller = document.querySelector('.content-scroller');
          if (element && scroller) {
            const elementOffsetTop = element.offsetTop;
            scroller.scrollTo({ top: Math.max(0, elementOffsetTop - 80), behavior: 'smooth' });
            return;
          }
          if (attempts > 0) setTimeout(() => scrollWhenReady(attempts - 1), 50);
        };

        exitHeroIfNeeded();
        setTimeout(() => scrollWhenReady(), 120);
      }
    }
  };

  return (
    <nav className={`navbar ${overHero ? 'over-hero' : 'scrolled-after-hero'}`}>
      <div className="navbar-container">
        {/* Desktop links - moved to left */}
        <div className="navbar-links">
          {location.pathname !== '/' && <Link to="/" className="nav-link">Home</Link>}
          <Link to="/about" className="nav-link">About</Link>
          {location.pathname === '/' && (
            <>
              <button className="nav-link" onClick={(e) => handleNavClick(e, 'learn-more')} style={{background: 'none', border: 'none', cursor: 'pointer'}}>Learn More</button>
              <button className="nav-link" onClick={(e) => handleNavClick(e, 'platforms')} style={{background: 'none', border: 'none', cursor: 'pointer'}}>Platforms</button>
            </>
          )}
          <Link to="/contact" className="nav-link">Contact</Link>
        </div>

        {/* Social media icons - moved to right */}
        {enabledPlatforms.length > 0 && (
          <div className="social-links">
            {enabledPlatforms.map((platform) => (
              <a
                key={platform.key}
                href={socialLinks[platform.key]?.url || '#'}
                className="social-link"
                aria-label={platform.name}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: platform.color }}
              >
                {platform.icon}
              </a>
            ))}
          </div>
        )}

        {/* Hamburger button (mobile) */}
        <button
          className="hamburger"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
          onClick={() => setMenuOpen((v) => !v)}
        >
          {/* Icon */}
          {!menuOpen ? (
            <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          ) : (
            <svg width="26" height="26" viewBox="AtIndex0 0 24 24" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          )}
        </button>
      </div>

      {/* Backdrop */}
      <button
        className={`mobile-backdrop ${menuOpen ? 'open' : ''}`}
        aria-hidden={!menuOpen}
        tabIndex={menuOpen ? 0 : -1}
        onClick={closeMenu}
      />

      {/* Drawer menu */}
      <aside
        id="mobile-menu"
        className={`mobile-menu ${menuOpen ? 'open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Navigation"
      >
        <nav className="mobile-menu-inner">
          {location.pathname !== '/' && <Link to="/" className="mobile-link" onClick={closeMenu}>Home</Link>}
          <Link to="/about" className="mobile-link" onClick={closeMenu}>About</Link>
          {location.pathname === '/' && (
            <>
              <button className="mobile-link" onClick={(e) => handleNavClick(e, 'learn-more')} style={{background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left'}}>Learn More</button>
              <button className="mobile-link" onClick={(e) => handleNavClick(e, 'platforms')} style={{background: 'none', border: 'none', cursor: 'pointer', width: '100%', textAlign: 'left'}}>Platforms</button>
            </>
          )}
          <Link to="/contact" className="mobile-link" onClick={closeMenu}>Contact</Link>
          
          {/* Social media links in mobile menu */}
          {enabledPlatforms.length > 0 && (
            <div className="mobile-social-links">
              {enabledPlatforms.map((platform) => (
                <a
                  key={platform.key}
                  href={socialLinks[platform.key]?.url || '#'}
                  className="mobile-social-link"
                  aria-label={platform.name}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: platform.color }}
                  onClick={closeMenu}
                >
                  {platform.icon}
                </a>
              ))}
            </div>
          )}
        </nav>
      </aside>
    </nav>
  );
};

export default Navbar;
